import { ReactNode } from 'react'

import { TableColumn } from '@driftt/tide-table'

export const toTideTableRow = (content, props?: any) => ({ ...props, content })

export const toTideTableColumnCreator =
  (
    currentSortKey: string,
    orderAsc: boolean,
    sortHandler: (key: string) => void
  ) =>
  (
    label: string | ReactNode,
    sortKey?: string,
    props?: Record<string, unknown>
  ): TableColumn => ({
    ...props,
    label,
    direction: orderAsc ? 'asc' : 'desc',
    sorting: !!sortKey && currentSortKey === sortKey,
    sortable: !!sortKey,
    onClick: sortKey && sortHandler ? () => sortHandler(sortKey) : undefined,
  })
